import { useState } from 'react';

export const useFilter = (
  initialFilters: string[] = [],
): [string[], (filter: string, value: boolean) => void] => {
  const [selectedFilters, setSelectedFilters] = useState(initialFilters);

  const resetFilter = () => {
    setSelectedFilters([]);
  };

  const addFilter = (filter: string) => {
    if (!selectedFilters.includes(filter)) {
      setSelectedFilters([...selectedFilters, filter]);
    }
  };

  const removeFilter = (filter: string) => {
    if (selectedFilters.length > 1) {
      const filterIndex = selectedFilters.indexOf(filter);

      selectedFilters.splice(filterIndex, 1);
      setSelectedFilters([...selectedFilters]);
    }
  };

  const handleFilter = (filter: string, newValue: boolean) => {
    if (filter === '') resetFilter();
    else if (newValue) addFilter(filter);
    else removeFilter(filter);
  };

  return [selectedFilters, handleFilter];
};
